import { MenuDivider } from '@chakra-ui/react'
import { ReactElement } from 'react'

export function getMenusWithDivider(items: ReactElement[]) {
  const result = items.reduce<ReactElement[]>((acc, item, index) => {
    if (index > 0) {
      acc.push(<MenuDivider />)
    }
    acc.push(item)
    return acc
  }, [])

  return result
}
